import ContentLoader from 'react-content-loader';

import { DEFAULT_SETTINGS } from '@web/consts/skeletonSettings';

export const MembersSkeleton = () => (
  <ContentLoader
    width={180}
    height={240}
    uniqueKey="conversation-skeleton-member"
    viewBox="0 0 180 240"
    {...DEFAULT_SETTINGS}>
    <rect x="0" y="20" rx="0" ry="0" width="90" height="10" />
    <rect x="20" y="40" rx="0" ry="0" width="100" height="10" />
    <rect x="20" y="60" rx="0" ry="0" width="80" height="10" />
    <rect x="20" y="80" rx="0" ry="0" width="120" height="10" />

    <rect x="0" y="110" rx="0" ry="0" width="100" height="10" />
    <rect x="20" y="130" rx="0" ry="0" width="60" height="10" />
    <rect x="20" y="150" rx="0" ry="0" width="120" height="10" />

    <rect x="0" y="180" rx="0" ry="0" width="140" height="10" />
    <rect x="0" y="200" rx="0" ry="0" width="120" height="10" />
  </ContentLoader>
);
